import { AST } from '@handlebars/parser';

import { NodeType } from '../../../node/types';

export const isBlockStatement = (statement: AST.Statement): statement is AST.BlockStatement =>
  statement.type === NodeType.BlockStatement;
